import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SectionHeader } from './SectionHeader'

interface OverviewSectionProps {
  description?: string
}

export const OverviewSection = ({ description }: OverviewSectionProps) => {
  const { t } = useTranslation(['eventManagement'])
  const [showMore, setShowMore] = useState(true)

  const shouldShowViewMoreButton = (description?.length ?? 0) > 135

  const buttonText = showMore
    ? t('eventManagement:common.viewMore')
    : t('eventManagement:common.viewLess')
  const buttonIcon = showMore ? <CaretDownIcon size={12} /> : <CaretUpIcon size={12} />

  return (
    <div className="overview-section">
      <SectionHeader header={t('eventManagement:common.overview')} />
      <p
        className={`overview-section__description${showMore ? ' overview-section__description--truncated' : ''}`}
      >
        {description || t('eventManagement:common.overviewPlaceholder')}
      </p>
      {shouldShowViewMoreButton && (
        <button
          className="overview-section__view-more-button"
          onClick={() => setShowMore((prev) => !prev)}
        >
          {buttonText} {buttonIcon}
        </button>
      )}
    </div>
  )
}
